import React, { useState, useEffect, useRef, useMemo } from "react"
import { useSnackbar } from 'notistack';
import axios from "../../../api/axios";
import { EventTabs } from "../../../utils/constants";
import JoditEditor, { Jodit } from "jodit-react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Box, Button, CircularProgress, Paper, Switch, Tab, Tabs, Typography } from "@mui/material";
import styles from './StatusForm.module.css';

const loadingPath='/api/events/';
const submitPath='/api/events/';
const switchSx = {
  "& .MuiSwitch-switchBase.Mui-checked": { color: "#0074c8" },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#0074c8" },
};

const StatusForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editor = useRef(null);
  
    const config = useMemo(
      () => ({
        readonly: false, // Set to true to make the editor read-only
      placeholder: 'Start typing your content here...',
      height: 400,
      toolbarButtonSize: 'middle',
      theme: 'default', // Options: 'default' or 'dark'
      enableDragAndDropFileToEditor: true,
      
      // Customize which toolbar buttons appear
      buttons: [
        'bold', 'italic', 'underline', 'strikethrough', '|',
        'ul', 'ol', '|',
        'font', 'fontsize', 'paragraph', '|',
        'image', 'table', 'link', '|',
        'align', 'undo', 'redo', '|',
        'hr', 'eraser', 'fullsize', 'source'
      ],
      
      // Configure file uploads
      uploader: {
        insertImageAsBase64URI: true // Quickly inserts images directly as base64
      },
      
      // Hide the bottom status bar statistics if desired
      showXPathInStatusbar: false,
      showCharsCounter: true,
      showWordsCounter: true,
      }),
      []
    );
  const [bomEvent, setFields] = useState({
    BP_Filled: false,
    BP_FilledText: '',
    BP_Reserved: false,
    BP_ReserveInstructions: '',
BP_ThankYouMessage: `
<p>Dear Volunteer,</p>
<p>Thank you for registering the following attendee(s) for <strong><a href="{%Domain%}/events/details/{%EventID%}">{%EventName%}</a></strong>.</p>
<p>{%Attendees%}</p>
<p>
  <strong>Next Step:</strong> Visit <a href="{%Domain%}/myreserved">My Reservations &amp; Payments</a> in the
  volunteer portal to continue registration by making payment for the
  event/project.
</p>
`,

BP_PendingApprovalMessage: `
<p>Dear Volunteer,</p>
<p>
  Your information has been submitted to the event coordinator of
  <strong><a href="{%Domain%}/events/details/{%EventID%}">{%EventName%}</a></strong> to be approved.
</p>
<p>
  If approved, you'll receive an email with instructions to complete your
  registration.
</p>
`,

BP_ApprovalMessage: `
<p>Dear Volunteer,</p>
<p>
  You have been approved to attend
  <strong><a href="{%Domain%}/events/details/{%EventID%}">{%EventName%}</a></strong> as a(n)
  <strong>{%Type%}</strong>.
</p>
<p>
  <strong>Next Step:</strong> Visit <a href="{%Domain%}/myreserved">My Reservations &amp; Payments</a> in the
  volunteer portal to continue registration by making payment for the
  event/project.
</p>
`,

BP_DeniedApprovalMessage: `
<p>Dear Volunteer,</p>
<p>
  Unfortunately, you have not been approved to attend
  <strong><a href="{%Domain%}/events/details/{%EventID%}">{%EventName%}</a></strong> as a(n)
  <strong>{%Type%}</strong>.
</p>
<p>
  <strong>What do I do now?</strong>
  Please contact us to discuss what volunteer opportunities we can still
  offer you.
</p>
`,

BP_BGCheckMessage: `
<p>
  Thank you for registering for <strong>{%EventName%}</strong>. As I’m sure
  you understand, our policy is that anyone age 18 and above who serves with
  children and youth must submit to a professional background check. The
  safety and well-being of the children is of primary importance. Thank you
  for your cooperation in this.
</p>

<p>
  Please click on the following link in order to begin the process of
  completing your background check:
</p>

<p class="center-block center">
  <a
    href="https://ciaresearch.com/ec=NCBaptist"
    target="_blank"
  >
    Submit Background Check
  </a>
</p>

<p>
  Your information will be reviewed by Protect My Ministry and results will be
  sent to us; this will take a few days. If any issues come up regarding your
  check, we will be in touch with you. Otherwise, you will receive an e-mail
  stating that your registration has been confirmed.
</p>
`,
BP_AdditionalMessage: `
<p>Your registration has been updated successfully!</p>
<p>The additional team member(s) have been added to your existing registration. A confirmation email has been sent to your inbox.
You can review your registration and complete any remaining payment from My Reservations & Payments, or by mail or phone.</p>
<p>The following team member(s) have been added to your registration for <strong>
<a href="{%Domain%}/events/details/{%EventID%}">
{%EventName%}
</a>
</strong>:</p>
<p>{%Attendees%}</p>
<p>Next Step: Visit <a href="{%Domain%}/myreserved">
My Reservations & Payments
</a> in the volunteer portal to review your updated registration or make any remaining payment for the event/project.</p>
`
    //add email fields
    //BP_ThankYouMessage : "<p>Dear Volunteer,</p><p>Thank you for registering the following attendee(s) for <strong><a href='http://{% Domain %}/details?eventid={%EventID%}' target='_blank'>{%EventName%}</a></strong>.</p><p>{%Attendees%}</p><p><span  style='font-family: Arial, sans-serif; color: #15c; font-weight: normal; text-transform: uppercase;'>Next Step</span> - Visit the volunteer portal <a href='http://{% Domain %}/Accounts/Dashboard/Orders' target='_blank'>orders page</a> to continue registration by making payment for the event/project.</p>",
    //BP_PendingApprovalMessage : "<p>Dear Volunteer,</p><p>Your information has been submitted to the event coordinator of <strong><a href='http://{% Domain %}/details?eventid={%EventID%}' target='_blank'>{%EventName%}</a></strong> to be approved.</p><p>If approved, you&#39;ll receive an email with instructions to complete your registration.</p>",
    //BP_ApprovalMessage : "<p>Dear Volunteer,</p><p>You have been approved to attend <strong><a href='http://{% Domain %}/details?eventid={%EventID%}' target='_blank'>{%EventName%}</a></strong> as a(n) <strong>{%Type%}</strong>.</p><p><span  style='font-family: Arial, sans-serif; color: #15c; font-weight: normal; text-transform: uppercase;'>Next Step</span> - Visit the volunteer portal <a href='http://{% Domain %}/Accounts/Dashboard/Orders' target='_blank'>orders page</a> to continue registration by making payment for the event/project.</p>",
    //BP_DeniedApprovalMessage : "<p>Dear Volunteer,</p><p>Unfortunately, you have not been approved to attend <strong><a href='http://{% Domain %}/details?eventid={%EventID%}' target='_blank'>{%EventName%}</a></strong> as a(n) <strong>{%Type%}</strong>.</p><p><span  style='font-family: Arial, sans-serif; color: #15c; font-weight: normal; text-transform: uppercase;'>What do I do now?</span> - Please <a href='http://{% Domain %}/Contact' target='_blank'>contact us</a>, to discuss what volunteer opportunities we can still offer you.</p>",
    //BP_NCBMBGCheckMessage: "<p>Thank you for registering for this project. As I’m sure you understand, our policy is that anyone age 18 and above who serves with children and youth must submit to a professional background check. The safety and well-being of the children is of primary importance. Thank you for your cooperation in this.</p><p>Please click on the following link in order to begin the process of completing your background check:</p><p class='center-block center'><a href='https://www.ministryopportunities.org/BSConventionNC' target='_blank' className='btn btn-primary'>Submit Background Check</a></p><p>Your information will be reviewed by Protect My Ministry and results will be sent to us; this will take a few days. If any issues come up regarding your check, we will be in touch with you. Otherwise, you will receive an e-mail stating that your registration has been confirmed.</p><div style='width:100%; border-bottom: #ccc 1px dotted; margin-top: 8px; margin-bottom: 18px;'></div>"
  });

  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [eventData, setEventData] = useState(null);
  const eventid = params.eventid;

  // Fetch event details for the header
  useEffect(() => {
    if (!eventid) return;
    let cancelled = false;
    const run = async () => {
      try {
        const resp = await axios.get(`/api/events/${eventid}`);
        if (!cancelled) setEventData(resp.data);
      } catch (e) {
        // Non-critical — header shows fallback text
      }
    };
    run();
    return () => { cancelled = true; };
  }, [eventid]);

    useEffect(() => {
      const fetchData = async () => {
        setIsLoading(true);
        try{
            const result = await axios.get(
              `${loadingPath}${eventid}`,
            );
          setFields(result.data);
          enqueueSnackbar('Events fetch success');
        }
          catch(error){
          setError(true)
        }
   
        
        setIsLoading(false);
      };

      //console.log('Tiny MCE API KEY: ',apiKey);

      fetchData();
  }, []);

 

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    
    
    const handleSubmit = async e => {
      e.preventDefault();

      let payload = { ...bomEvent };
      delete payload.EventAgreements;
      delete payload.AgreementTemplate;

      try {
        let response = await axios.put(submitPath + eventid, payload);
       // console.log(response);
        if (response) {
          enqueueSnackbar("Status Saved");
        }
      } catch (err) {
        console.error('Status save failed:', err);
        enqueueSnackbar('Failed to save status', { variant: 'error' });
      }
}
  
   //handlefieldchange
function handleCheckboxChange(input){
  const target = input.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.id;
    //console.log(name,value);
    setFields({...bomEvent,
      [name]: value
    });
}

const handleTabChange = (_, newValue) => {
  const tab = EventTabs.find(t => t.name === newValue);

  if (!tab || !eventid) {
    return;
  }

  navigate(`/admin/events/${tab.path}/${eventid}`);
};
    


  const urlSegment =
  location.pathname.split("/")[3]?.toLowerCase() || "general";

const activeTabName =
  (
    EventTabs.find(
      t => t.path.toLowerCase() === urlSegment
    ) ||
    EventTabs[0]
  ).name;


  const headerTitle = eventData?.BP_Title
  ? `Edit Status: ${eventData.BP_Title}`
  : 'Edit Status';

  // Shared WYSIWYG config: adds the Insert/Edit Link control and a file picker
  // that uploads to blob storage and inserts the returned URL as a link.
  const editorInit = {
    height: 300,
    menubar: true,
    branding: false,
    plugins: 'link',
    // Exactly the original default buttons, plus the Link button at the end.
    toolbar: 'undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link',
    file_picker_types: 'file',
    file_picker_callback: (callback, value, meta) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.onchange = () => {
        const file = input.files && input.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file);
        const token = localStorage.getItem('token');
        // Plain axios instance (no default JSON content-type) so the browser
        // sets the multipart boundary; auth header attached manually.
        axios
          .post('/api/files/upload', formData, {
            headers: { Authorization: token ? `Bearer ${token}` : undefined },
          })
          .then((res) => {
            const uploadedUrl = res.data && res.data.url;
            if (!uploadedUrl) {
              enqueueSnackbar('Upload succeeded but no URL was returned.', { variant: 'error' });
              return;
            }
            // Populate the dialog's URL field with the uploaded file link.
            callback(uploadedUrl, { text: file.name, title: file.name });
            enqueueSnackbar('File uploaded. Link added to the URL box, click Save to insert it.', { variant: 'success' });
          })
          .catch((e) => {
            console.error('File upload failed', e);
            enqueueSnackbar('File upload failed: ' + (e?.response?.data?.error || e.message), { variant: 'error' });
          });
      };
      input.click();
    },
  };

return (
<main>
  {/* Blue Header Banner */}
  <div className="full-row light-blue">
    <div className="container-fluid">
      <div className="row text-white pt-3 pb-3">
        <div className="col-md-12 text-white">
          <h1 className="text-uppercase">{headerTitle}</h1>
          <p>Manage event status details</p>
        </div>
      </div>
    </div>
  </div>

  {/* Content Area */}
  <div className="full-row white">
    {/* Sticky Tab Bar */}
    <Box
      sx={{
        position: 'sticky',
        top: 40,
        zIndex: 100,
        backgroundColor: 'white',
        borderBottom: 1,
        borderColor: 'divider',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
      }}
    >
      <Box sx={{ px: 3 }}>
        <Tabs
  value={activeTabName}
  onChange={handleTabChange}
  variant="scrollable"
  scrollButtons="auto"
  allowScrollButtonsMobile
  TabIndicatorProps={{
    sx: {
      height: 3,
      borderRadius: 2,
      backgroundColor: "#0074c8"
    }
  }}
  sx={{
    minHeight: 44,
    "& .MuiTabs-flexContainer": {
      gap: 1
    },
    "& .MuiTab-root": {
      textTransform: "none",
      fontFamily: "proxima-nova, sans-serif",
      fontWeight: 600,
      fontSize: { xs: 14, sm: 16 },
      minHeight: 44,
      px: 2,
      borderRadius: 1,
      whiteSpace: "nowrap",
      color: "text.primary",

      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.06)"
      },

      "&.Mui-selected": {
        color: "#0074c8"
      }
    }
  }}
>
  {EventTabs.map((t) => (
    <Tab
      key={t.id}
      value={t.name}
      label={t.label || t.name}
      wrapped={false}
    />
  ))}
</Tabs>
      </Box>
    </Box>

  <Box sx={{ p: 3 }}>
    <Paper sx={{ p: 2 }}>
      <form onSubmit={handleSubmit}>
          
          {/* Section 1: Event status messages */}
          <div className={styles.formSection}>
            <h2 className={styles.sectionTitle}>Event Status Messages</h2>
            <div className={styles.sectionDescription}>
              Configure messages for different event availability states
            </div>

            {/* Event Filled */}
            <div className={styles.messageBlock}>
              <div className={styles.toggleCard}>
                <div className={styles.toggleHeader}>
                  <Switch
                    id="BP_Filled"
                    checked={bomEvent.BP_Filled || false}
                    onChange={handleCheckboxChange}
                    size="small"
                    sx={switchSx}
                  />
                  <label htmlFor="BP_Filled" className={styles.toggleLabel}>
                    <span className={styles.toggleTitle}>Event is Filled</span>
                    <span className={styles.toggleDescription}>
                      Mark this event as full and display a custom message to visitors
                    </span>
                  </label>
                </div>
                
                {bomEvent.BP_Filled && (
                  <div className={styles.toggleContent}>
                    <Box>
                      <Typography variant="subtitle2" sx={{ mb: 1 }}>Filled Event Message *</Typography>
                      <JoditEditor
                        ref={editor}
                        id="BP_FilledText"
                        value={bomEvent.BP_FilledText || ''}
                        config={config}
                        onChange={(content) => setFields(prev => ({...prev, BP_FilledText: content}))}
                      />
                      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
                        This message will be displayed when the event has reached capacity
                      </Typography>
                    </Box>
                  </div>
                )}
              </div>
            </div>

            {/* Event Reserved */}
            <div className={styles.messageBlock}>
              <div className={styles.toggleCard}>
                <div className={styles.toggleHeader}>
                  <Switch
                    id="BP_Reserved"
                    checked={bomEvent.BP_Reserved || false}
                    onChange={handleCheckboxChange}
                    size="small"
                    sx={switchSx}
                  />
                  <label htmlFor="BP_Reserved" className={styles.toggleLabel}>
                    <span className={styles.toggleTitle}>Event is Reserved</span>
                    <span className={styles.toggleDescription}>
                      Mark this event as reserved for specific groups with custom instructions
                    </span>
                  </label>
                </div>
                
                {bomEvent.BP_Reserved && (
                  <div className={styles.toggleContent}>
                    <Box>
                      <Typography variant="subtitle2" sx={{ mb: 1 }}>Reservation Instructions *</Typography>
                      <JoditEditor
                      ref={editor}
                        id="BP_ReserveInstructions"
                        value={bomEvent.BP_ReserveInstructions || ''}
                        config={config}
                        onChange={(content) => setFields(prev => ({...prev, BP_ReserveInstructions: content}))}
                      />
                      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
                        Instructions for users viewing a reserved event
                      </Typography>
                    </Box>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Section 2: Registration messages */}
          <div className={styles.formSection}>
            <h2 className={styles.sectionTitle}>Registration Messages</h2>
            <div className={styles.sectionDescription}>
              Customize messages shown to users during and after registration
            </div>

            {/* Thank You Message */}
            <div className={styles.messageBlock}>
              <div className={styles.messageHeader}>
                <div className={styles.messageIcon} style={{background: '#0074c8'}}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className={styles.messageTitle}>Thank You Message</h3>
                  <p className={styles.messageSubtitle}>Shown after successful registration</p>
                </div>
              </div>
              <Box>
                <JoditEditor
                  ref={editor}
                  id="BP_ThankYouMessage"
                  value={bomEvent.BP_ThankYouMessage || ''}
                  config={config}
                  onChange={(content) => setFields(prev => ({...prev, BP_ThankYouMessage: content}))}
                />
                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
                  Message displayed to users immediately after they complete registration
                </Typography>
              </Box>
            </div>
          </div>

          {/* Existing Thank You Message */}
            <div className={styles.messageBlock}>
              <div className={styles.messageHeader}>
                <div className={styles.messageIcon} style={{background: '#0074c8'}}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className={styles.messageTitle}>Existing Registration Message</h3>
                  <p className={styles.messageSubtitle}>Shown after attendee signs up more attendees for the same event</p>
                </div>
              </div>
              <Box>
                <JoditEditor
                  ref={editor}
                  id="BP_AdditionalMessage"
                  value={bomEvent.BP_AdditionalMessage || ''}
                  config={config}
                  onChange={(content) => setFields(prev => ({...prev, BP_AdditionalMessage: content}))}
                />
                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
                  Message displayed to users immediately after they add onto an existing registration
                </Typography>
              </Box>
            </div>

          {/* Section 3: Approval workflow messages */}
          <div className={styles.formSection}>
            <h2 className={styles.sectionTitle}>Approval Workflow Messages</h2>
            <div className={styles.sectionDescription}>
              Messages for events requiring approval before registration is confirmed
            </div>

            {/* Pending Approval */}
            <div className={styles.messageBlock}>
              <div className={styles.messageHeader}>
                <div className={styles.messageIcon} style={{background: '#0074c8'}}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className={styles.messageTitle}>Pending Approval Message</h3>
                  <p className={styles.messageSubtitle}>Shown while registration is awaiting approval</p>
                </div>
              </div>
              <Box>
                <JoditEditor
                  ref={editor}
                  id="BP_PendingApprovalMessage"
                  value={bomEvent.BP_PendingApprovalMessage || ''}
                  config={config}
                  onChange={(content) => setFields(prev => ({...prev, BP_PendingApprovalMessage: content}))}
                />
                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
                  Message displayed to users waiting for their registration to be approved
                </Typography>
              </Box>
            </div>

            {/* Approved */}
            <div className={styles.messageBlock}>
              <div className={styles.messageHeader}>
                <div className={styles.messageIcon} style={{background: '#0074c8'}}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className={styles.messageTitle}>Approval Confirmation Message</h3>
                  <p className={styles.messageSubtitle}>Shown when registration is approved</p>
                </div>
              </div>
              <Box>
                <JoditEditor
                  ref={editor}
                  id="BP_ApprovalMessage"
                  value={bomEvent.BP_ApprovalMessage || ''}
                  config={config}
                  onChange={(content) => setFields(prev => ({...prev, BP_ApprovalMessage: content}))}
                />
                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
                  Message displayed when a user's registration has been approved
                </Typography>
              </Box>
            </div>

            {/* Denied */}
            <div className={styles.messageBlock}>
              <div className={styles.messageHeader}>
                <div className={styles.messageIcon} style={{background: '#0074c8'}}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className={styles.messageTitle}>Denied Approval Message</h3>
                  <p className={styles.messageSubtitle}>Shown when registration is not approved</p>
                </div>
              </div>
              <Box>
                <JoditEditor
                  ref={editor}
                  id="BP_DeniedApprovalMessage"
                  value={bomEvent.BP_DeniedApprovalMessage || ''}
                  config={config}
                  onChange={(content) => setFields(prev => ({...prev, BP_DeniedApprovalMessage: content}))}
                />
                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
                  Message displayed when a user's registration is denied
                </Typography>
              </Box>
            </div>
          </div>
          
          {/* Section 4: Background check message */}
          <div className={styles.formSection}>
            <h2 className={styles.sectionTitle}>Background Check Message</h2>
            <div className={styles.sectionDescription}>
              Message with background-check instructions, sent to registrants who are required to complete one
            </div>

            <div className={styles.messageBlock}>
              <div className={styles.messageHeader}>
                <div className={styles.messageIcon} style={{background: '#0074c8'}}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 11l3 3L22 4M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
                  </svg>
                </div>
                <div>
                  <h3 className={styles.messageTitle}>Background Check Message</h3>
                  <p className={styles.messageSubtitle}>Shown to registrants who must complete a background check</p>
                </div>
              </div>
              <Box>
                <JoditEditor
                  ref={editor}
                  id="BP_BGCheckMessage"
                  value={bomEvent.BP_BGCheckMessage || ''}
                  config={config}
                  onChange={(content) => setFields(prev => ({...prev, BP_BGCheckMessage: content}))}
                />
                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
                  Message displayed to registrants who are required to complete a background check
                </Typography>
              </Box>
            </div>
          </div>

          {/* Action Buttons */}
          <Box className={styles.actionButtons}>
            <Button variant="contained" type="submit">
              Save Messages
            </Button>
            <Button variant="outlined" type="button" onClick={() => navigate('/admin/events')}>
              Cancel
            </Button>
          </Box>
      </form>
    </Paper>
  </Box>
  </div>
</main>
    );
  }

export default StatusForm;
